import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/org-chart-structures',
    name: 'org-chart-structure',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/org-chart-structure'),
    beforeEnter: async (to, from, next) => {
      await Promise.all([
        store.dispatch('hr/orgChartStructure/fetchCompanies'),
        store.dispatch('hr/orgChartStructure/fetchOrgChartLevel'),
        store.dispatch('hr/orgChartStructure/fetchParentStructures')
      ])

      next()
    }
  }
]
